import React from "react";
import { Link } from "react-router-dom";
import { useProductContext } from "../../context/ProductContext";

const BlogPage = () => {
  const { blog, isLoading } = useProductContext();
  
  return (
    <section id="product1" className="section-p1">
      <h2 style={{ textAlign: "center", fontWeight: "bold" }}>BLOGS</h2>

      <div className="pro-container" style={{ flexDirection: "column" }}>
        {isLoading ? (
          <h5>Loading......</h5>
        ) : (
          blog.map((data) => {
            return (
              <div className="pro blog" style={{ width: "100%" }} key={data.id}>
                <div className="blog-img">
                  <img src={data.image} alt="hhh" />
                </div>
                <div className="blog-details">
                  <div className="blog-header">
                    <div>
                      <h2>{data.title}</h2>
                      <span>{data.subtitle}</span>
                    </div>
                    <div>
                      <p>
                        <b>Author : {data.author}</b>
                      </p>
                      <span>{data.pub_date}</span>
                    </div>
                  </div>

                  <div className="mt-2">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.description.slice(0, 250),
                      }}
                    ></div>
                    <Link
                      to={`/blogdetails/${data.id}`}
                      style={{ textDecoration: "none", color: "#0c0c0c" }}
                    >
                      Read more...
                    </Link>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </section>
  );
};

export default BlogPage;
